export const PERSONAL_CATEGORIES = [
  'Personal',
  'Grandmother',
  'Medical',
  'Temple / Pooja Items',
  'Shopping',
  'Grooming'
];

export const isPersonalCategory = (category) => {
  if (!category) return false;
  const normalized = category.trim().toLowerCase();
  return (
    normalized === 'personal' ||
    normalized === 'grandmother' ||
    normalized === 'medical' ||
    normalized === 'temple / pooja items' ||
    (normalized.startsWith('temple') && normalized.includes('pooja')) ||
    normalized === 'shopping' ||
    normalized === 'grooming'
  );
};
